"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = exports.TableCell = exports.TableBody = exports.TableHeader = exports.Table = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = require("react");
const TableElement = styled_components_1.default.table.attrs((props) => ({
    columns: props.columns || false
})) `
  ${({ borders, columns, theme }) => columns
    ? `
      display: grid;
      grid-template-columns: ${columns};    
      thead,
      tbody,
      tr {
        display: contents;
      }
      tr:not(:last-child) {
        td, th {
          border-bottom: 1px solid ${borders ? theme.colors.silverLighten40 : "transparent"};
        }      
      }
  `
    : ""}

  ${({ borders, theme }) => borders && borders == "all"
    ? `
      border: 1px solid ${theme.colors.silverLighten40};
  `
    : ""}

  ${({ borders, theme }) => borders
    ? `
    tr:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.silverLighten40}
    }    
  `
    : ""}

  td,
  th {
    padding: ${({ theme }) => theme.spacings.xs} 0;
  }
`;
const TableHeader = (props) => {
    return (0, react_1.createElement)("th", props, props.children);
};
exports.TableHeader = TableHeader;
const TableBody = (props) => {
    return (0, react_1.createElement)("tbody", props, props.children);
};
exports.TableBody = TableBody;
const TableRow = (props) => {
    return (0, react_1.createElement)("tr", props, props.children);
};
exports.TableRow = TableRow;
const TableCell = (props) => {
    return (0, react_1.createElement)("td", props, props.children);
};
exports.TableCell = TableCell;
const Table = (props) => {
    return (0, react_1.createElement)(TableElement, props, props.children);
};
exports.Table = Table;
//# sourceMappingURL=index.js.map